// 'use strict';

// define(['underscore', 'three', './hit'], function (_, THREE, Hit) {

import * as THREE from 'three'
import Hit from './hit'

function HitSpread(arr) {
    THREE.Group.call(this)

    const spread = new THREE.Group()
    spread.name = 'spread'

    arr.forEach((item) => {
        spread.add(item)
    })

    this.add(spread)
}

HitSpread.prototype = Object.create(THREE.Group.prototype)
HitSpread.prototype.constructor = HitSpread

HitSpread.prototype.addHit = function (data, opts) {
    const spread = this.getObjectByName('spread')
    const hit = Hit.fromData(data, opts)
    spread.add(hit)
    return hit
}

// TODOHI  implement - need to remove meshes, geometries, and materials?
HitSpread.prototype.clear = function () {}

HitSpread.prototype.getHitObjects = function () {
    return this.getObjectByName('spread').children
}

HitSpread.prototype.getHit = function (id) {
    const spread = this.getObjectByName('spread')
    return spread.getObjectByName(id)
}

HitSpread.prototype.showAll = function (from, to) {
    const spread = this.getObjectByName('spread')

    spread.children.forEach((hit) => {
        hit.show(from, to)
    })
}

HitSpread.fromDataArray = function (arr) {
    return arr.map((json) => Hit.fromData(json))
}

HitSpread.empty = function () {
    return new HitSpread([])
}

export default HitSpread
